function StatusBar({ status, head, content }) {
    return (
        <div className={`status-bar status-bar--${status}`}>
            <div className="status-bar__head">
                { head }
            </div>

            <div className="status-bar__content">
                { content }
            </div>
        </div>
    )
}

export default StatusBar;